var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-link link-primary underline-link-from-center",on:{"click":function($event){return _vm.add()}}},[_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":"bookmark"}}),_vm._v(" "+_vm._s(_vm.$t('saveForLater'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }